<invoice-tag>
<div class="contents contents-wide">
  <section class="contents_area">
    <div class="container_heading">
      <h1 class="heading-01 heading_invoices">請求一覧</h1>
      <ul class="breadcrumb">
        <li class="breadcrumb-item"><a href="/menu" class="home">ホーム</a></li>
        <li class="breadcrumb-item">請求一覧</li>
      </ul>
    </div><!--/.container_heading-->
    
    <div class="lead_block">
      <p>CROCOデスク、CROCOデスクオンラインの各種サービスで発生した請求一覧表示しております。</p>
    </div><!--/.lead_block-->
    
    <div class="table-nav_area">
      <div class="search-conditions_area">
        <p class="search-conditions-heading">現在の検索条件：</p>
        <ul class="search-conditions-list">
          <li class="search-conditions-list-item" each={item in searchConditions()}>
            <span class="label label-search-conditions" onclick={(e)=>deleteCond(e, item.key)}>
              {item.name}: {item.value}
            </span>
          </li>
        </ul>
      </div><!--/.search-conditions_area-->
      <button class="button button-modal button-modal-search js-modal-open" type="button" value="検索条件設定" onclick={(e)=>{MenuApi.event('invoice','openSearchModal')}}>検索条件設定</button>
    </div><!--/.table-nav_area-->
    
    <div class="table-nav_area">
      <p class="search_number">全{state.datainfo.total}件中　{state.datainfo.start}〜{state.datainfo.end}件</p>
      <div class="sort-menu">
        <label for="sort" class="sort-menu-title">表示件数</label>
        <select name="sort" id="sort" class="sort-list" onchange={(e)=>setlimit(e)}>
          <option value="10">10件</option>
          <option value="20">20件</option>
          <option value="50">50件</option>
          <option value="100">100件</option>
        </select>
      </div><!--/.sort-menu-->
    </div><!--/.table-nav_area-->

    <invoice-list-tag
      MenuApi={MenuApi}
      params={state.params}
      updatePage={updatePage}
      setOrderBy={setOrderBy}
      pagerBinder={pagerBinder}
    ></invoice-list-tag>

    <invoice-search-modal
      modalId="invoice-search-modal"
      MenuApi={MenuApi}
      search={search}
    ></invoice-search-modal>

  </section><!--/.contents_area-->
</div><!--/.contents-->

<script>
  import di from "dependency-injection";
  import invoiceListTag from "@tags/parts/invoice-list.riot";
  import invoiceSearchModal from "@tags/modal/menu/invoice-search-modal.riot";
  import Status from "@model/status.js";
  export default {
    MenuApi: false,
    state: {
      params: {},
      datainfo: {total: 0, start: 0, end:0}
    },
    components: {
      "invoice-list-tag": invoiceListTag,
      "invoice-search-modal": invoiceSearchModal
    },
    pagerBinder(pager){
      const start = 1 + ((pager.page -1) * (this.state.params.limit || 10));
      this.update({datainfo:{
        total: pager.total,
        start: start,
        end: start + pager.items.length - 1
      }});
    },
    searchConditions(){
      const items = [];
      const conditions = {
        status: 'ステータス',
        //staff: '担当者',
        invoice_id: '請求書番号',
        service: 'サービス',
        range_start: '請求日(開始)',
        range_end: '請求日(終了)',
      };
      Object.keys(this.state.params)
      .filter(k => Object.keys(conditions).indexOf(k) != -1)
      .filter(k => this.state.params[k])
      .forEach( (k) => {
        let val = this.state.params[k];
        if (k === 'status') val = Status.invoice(this.state.params[k]).text;
        items.push({
          key: k,
          name: conditions[k],
          value: val
        });
      });
      return items;
       
    },
    setlimit(e){
      let lim = $("select[name=limit]").val();
      this.state.params.limit = lim;
      this.state.params.page = 1;
      this.update();
      this.MenuApi.event('invoice', 'search');
    },
    setOrderBy(direction){
      this.state.params.orderby = direction;
      this.state.params.page = 1;
      this.update();
      this.MenuApi.event('invoice', 'search');
    },
    updatePage(pageNo) {
      this.state.params.page = pageNo;
      this.update();
      this.MenuApi.event('invoice', 'search');
    },
    deleteCond(e, k) {
      delete this.state.params[k];
      this.update();
      this.MenuApi.event('invoice', 'search');
    },
    search(params) {
      params.limit = this.state.params.limit;
      this.update({params: params});
      this.MenuApi.event('invoice', 'search');
    },
    onBeforeMount(){
      this.MenuApi = di.createApi();
    }
  }
</script>
</invoice-tag>
